@if(isLogin){
<div class="flex items-center justify-center min-h-screen bg-gray-50">
  <div class="bg-white p-8 sm:p-10 rounded-2xl shadow-lg w-full max-w-sm border border-gray-200/50">
    <div class="flex flex-col items-center">
      <div class="bg-indigo-100 p-4 rounded-full">
        <svg class="w-8 h-8 text-indigo-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" />
        </svg>
      </div>
      <h1 class="text-2xl font-bold text-gray-800 mt-4">{{'LOGINHQ0001' | translate}}</h1>
      <!-- <p class="text-gray-500 text-sm mt-1">Secure Point of Sale Access</p> -->
    </div>

    <div class="mt-8 space-y-6">
      <div>
        <label for="storeId" class="fs-14 px-1">{{'LOGINHQ0002' | translate}}</label>
        <input id="storeId" name="storeId" type="text"
          [ngClass]="bodyAuthenUsername.username.length == 0 && submit ? 'ng-invalid' : ''"
          [(ngModel)]="bodyAuthenUsername.username" required pInputText (keydown.enter)="onLogin()" class="w-full">
        <div *ngIf="bodyAuthenUsername.username.length == 0 && submit">
          <p class="text-red-500 fs-12 text-ellipsis" [pTooltip]=" 'LOGINHQ0007' | translate ">
            {{ 'LOGINHQ0007' | translate }}
          </p>
        </div>
      </div>
      <div>
        <label for="password" class="fs-14 px-1">{{'LOGINHQ0003' | translate}}</label>
        <p-password [(ngModel)]="bodyAuthenUsername.password" [toggleMask]="true" [feedback]="false" class="w-full"
          [ngClass]="{ 'ng-invalid ng-dirty': submit && !bodyAuthenUsername.password }" (keydown.enter)="onLogin()"
          inputStyleClass="w-full" />
        <div *ngIf="bodyAuthenUsername.password.length == 0 && submit">
          <p class="text-red-500 fs-12 text-ellipsis" [pTooltip]=" 'LOGINHQ0008' | translate ">
            {{ 'LOGINHQ0008' | translate }}
          </p>
        </div>
        <!-- <input id="password" name="password" type="password" [ngModel]="password()"
          (ngModelChange)="password.set($event)" required
          class="w-full px-4 py-3 mt-1 bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-shadow"> -->
      </div>
      <div class="flex justify-between">
        <div class="flex items-center">
          <p-checkbox [(ngModel)]="checked_remember" id="rememberme1" binary class="mr-2"></p-checkbox>
          <label for="rememberme1" class="fs-14 fw-500 clr-gray">{{'LOGINHQ0004' | translate}}</label>
        </div>
        <div class="flex items-center">
          <p-checkbox [(ngModel)]="checked_auto" id="autologin" binary class="mr-2"></p-checkbox>
          <label for="autologin" class="fs-14 fw-500 clr-gray">{{'LOGINHQ0005' | translate}}</label>
        </div>

      </div>
      <button type="submit" (click)="onLogin()"
        class="w-full flex justify-center items-center bg-indigo-600 text-white font-semibold py-3 px-4 rounded-lg hover:bg-indigo-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed">
        <span>{{'LOGINHQ0001' | translate}}</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd"
            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
            clip-rule="evenodd" />
        </svg>
      </button>

      <div class="mt-5 flex justify-center"><a (click)="isLogin = false" class="fs-14 fw-500 clr-gray">{{'LOGINHQ0010' |
          translate}}</a></div>
    </div>
  </div>
</div>

<p-dialog [header]="'STOREHQ0047' | translate" [modal]="true" [(visible)]="showStore" [closable]="false"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="false">
  <div *ngIf="showStore">
    <div class="flex flex-col gap-3">
      <div class="grid grid-cols-12 gap-3">
        <div class="col-span-10">
          <input pInputText type="text" [(ngModel)]="param.P_STR_NM" [placeholder]="'STOREHQ0048' | translate"
            (keydown.enter)="getStore()" class="w-full" maxlength="50">
        </div>
        <div class="col-span-2">
          <button (click)="getStore()"
            class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white fs-14 rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-full">{{'PAYMESTR0046'
            | translate}}</button>
        </div>
      </div>
      <p-table [value]="stores" dataKey="stR_CD" #tb showGridlines paginator="true" [rows]="P_PAGEROW"
        [totalRecords]="totalCnt" [lazy]="true" (onLazyLoad)="loadPage($event)">
        <ng-template #header>
          <tr>
            <th class="w-[20%]">{{'STOREHQ0005' | translate}}</th>
            <th class="w-[50%]">{{'STOREHQ0006' | translate}}</th>
            <th class="w-[30%]">{{'STOREHQ0007' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template #body let-store>
          <tr class="cursor-pointer" (click)="selectStore(store)">
            <td class="text-left">{{ store.stR_CD }}</td>
            <td class="text-left">{{ store.stR_NM }}</td>
            <td class="text-left">{{ store.stR_STAT_NM }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="100%" style="text-align: center;">
              {{'SYSMESER0004' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>
}
@else {
<components-forgot-pass (loginClick)="isLogin = true"></components-forgot-pass>
}